import type { I18nOptions } from 'vue-i18n';
import { createI18n } from 'vue-i18n';

import datetimeFormats from '#ui-shared/i18n/rules/dates';
import { numberFormats } from '#ui-shared/i18n/rules/numbers';

import * as en_GB from './locales/en_GB.json';

const i18nOptions: I18nOptions = {
  locale: 'en-GB',
  fallbackLocale: 'en-GB',
  legacy: false,
  messages: { 'en-GB': en_GB },
  globalInjection: true,
  numberFormats,
  datetimeFormats,
};

export const i18n = createI18n<false, typeof i18nOptions>(i18nOptions);

/**
 * A global wrapper that takes the i18n to avoid i18n.global.t when useI18n can't be used.
 *
 * @param key – the translation key, e.g. 'errors.network'
 * @param plural – the pluralisation number, e.g. 1, 2, 3
 * @returns the localized string
 */
export function t<Key extends string>(key: Key, plural = 2): string {
  return i18n.global.t(key, plural) as string;
}
